import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  margin-top: 148px;
  background: url(/assets/images/gradient_background.webp) center / cover
    no-repeat;
  box-shadow: 0px 0px 20px 3px var(--hover3, #7879f133);
  display: flex;
  justify-content: center;
  padding: 0 24px;
  box-sizing: border-box;
  @media (max-width: 900px) {
    margin-top: 64px;
    padding: 0 24px;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: var(--unsignedMaxWidth);
  height: 206px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  box-sizing: border-box;
  @media (max-width: 900px) {
    flex-direction: column;
    height: auto;
    padding: 32px 18px 0 18px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    padding: 24px 18px 0 18px;
  }
`

export const ImgCol = styled.div`
  display: flex;
  align-items: flex-end;
  align-self: flex-end;
  flex-shrink: 0;
  margin-left: 80px;

  @media (max-width: 1200px) {
    margin-left: 32px;
  }

  @media (max-width: 900px) {
    align-self: center;
    align-items: center;
    justify-content: center;
    order: 3;
    margin-left: 0;
  }
  @media (max-width: 600px) {
    align-items: flex-end;
    justify-content: center;
    margin: 0 auto 0 auto;
    width: 200px;
    height: 182px;
    display: flex;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: left;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    order: 1;
    width: 100%;
  }
  @media (max-width: 600px) {
    margin-bottom: 12px;
  }
`

export const Text = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 140%;
  letter-spacing: 0%;
  color: var(--blue6, #21105d);
  margin-left: 30px;
  margin-right: 30px;
  text-align: left;
  @media (max-width: 900px) {
    margin: 0 0 24px 0;
    text-align: center;
    font-size: 18px;
  }
  @media (max-width: 600px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    margin: 0 0 12px 0;
    br {
      display: none;
    }
  }
`

export const ButtonCol = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
  @media (max-width: 900px) {
    margin-top: 24px;
    justify-content: center;
    width: 100%;
    order: 2;
  }
  @media (max-width: 600px) {
    margin: 0 auto 12px auto;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`

export const CTAButton = styled.button`
  width: 222px;
  height: 64px;
  border-radius: 10px;
  padding: 16px;
  background: var(--orange3, #f88621);
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: var(--orange2, #f2994a);
  }
  @media (max-width: 600px) {
    width: auto;
    height: auto;
    padding: 10px;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
  }
`
